import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HousingSubscription, HCustomerSubscriptionDto, Partner, HPaymentDto, PaymentResponseDto } from '../../api/models';
import {  HPaymentControllerService , ReceiptControllerService } from '../../api/services';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { QRCodeComponent } from 'angularx-qrcode';
import { AngularDeviceInformationService } from 'angular-device-information';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'app-payment',
  imports: [
    CommonModule,
    ReactiveFormsModule,QRCodeComponent
  ],
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.css'
})
export class PaymentComponent implements OnInit {

  searchForm: FormGroup;
  paymentForm: FormGroup;
  submitted = false;
  isSearching = true;
  isSelectingPromoter = false;
  isSelectingSubscription = false;
  isPayment = false;
  clickedPayForm=false;
  qrCode='';
  

  customerData?: HCustomerSubscriptionDto;
  promoters: Partner[] = [];
  selectedPromoter?: Partner;
  promoterSubscriptions: HousingSubscription[] = [];
  selectedSubscription?: HousingSubscription;
  paymentMultiplier = 1;
  calculatedAmount = 0;

  message = '';
  messageType: 'text-success' | 'text-info' | 'text-danger' = 'text-success';

  paymentNetwork = '';
  fees = 0;
  isWallet = false;
  taxe = 0;
  idempotencyKey = '';
  paymentNetworkOtpion = '';
  isDesktop:boolean;

  paymentMethods = [
    { code: 'card', label: 'Carte bancaire', icon: 'images/visamaster.png' },
    { code: 'omsn', label: 'Orange Money', icon: 'images/omsn.webp' },
    { code: 'wvsn', label: 'Wave', icon: 'images/wave-logo.webp' }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private receiptService:ReceiptControllerService,
    private hpaymentService: HPaymentControllerService,
    private deviceInfo:AngularDeviceInformationService,
    private router:Router
  ) {
    this.searchForm = this.formBuilder.group({
      phone: ['', [Validators.required, Validators.pattern('^[0-9+]+$')]]
    });

    this.paymentForm = this.formBuilder.group({
      phone: ['', [Validators.required, Validators.pattern('^[0-9+]+$')]],
      amount: ['', [Validators.required, Validators.min(1)]]
    });

    this.isDesktop=deviceInfo.isDesktop();
  }

  ngOnInit(): void {
  }

  get f() {
    return this.searchForm.controls;
  }

  get p() {
    return this.paymentForm.controls;
  }

  searchCustomer(): void {
    if (this.searchForm.invalid) {
      return;
    }

    const phone = this.searchForm.value.phone.trim();

    this.hpaymentService.getSubscriptionByCustomerPhone(phone).subscribe({
      next: (response: HCustomerSubscriptionDto) => {
        this.customerData = response;
        this.extractPromoters();
        this.isSearching = false;
        this.isSelectingPromoter = true;
        this.messageType = 'text-success';
        this.message = response.customer?.firstName+' '+response.customer?.lastName;
      },
      error: (error) => {
        this.messageType = 'text-danger';
        this.message = error.error?.message || 'Erreur lors de la recherche du client';
        console.error('Erreur lors de la recherche du client', error);
      }
    });
  }

  private extractPromoters(): void {
    if (!this.customerData?.subscriptions) return;

    const promoterMap = new Map<number, Partner>();

    this.customerData.subscriptions.forEach(subscription => {
      if (subscription.product?.promoter && !promoterMap.has(subscription.product.promoter.id!)) {
        promoterMap.set(subscription.product.promoter.id!, subscription.product.promoter);
      }
    });

    this.promoters = Array.from(promoterMap.values());
  }

  selectPromoter(event: any): void {
    console.log("selecting promoter ",event.target.value);
    const promoterId= Number(event.target.value);
    if(promoterId>0){
    this.selectedPromoter = this.promoters.filter(p=>p.id==promoterId).at(0);
    this.loadPromoterSubscriptions();
    this.isSelectingPromoter = false;
    this.isSelectingSubscription = true;
    }else {
      this.selectedPromoter=undefined;
      this.isSelectingSubscription=false;
      this.isSelectingPromoter=true;
    }
  }

  private loadPromoterSubscriptions(): void {
    if (!this.customerData?.subscriptions || !this.selectedPromoter) return;

    this.promoterSubscriptions = this.customerData.subscriptions.filter(
      subscription => subscription.product?.promoter?.id === this.selectedPromoter?.id
    );
  }

  selectSubscription(subscription: HousingSubscription): void {
    this.selectedSubscription = subscription;
    this.calculateAmount();
    this.isSelectingSubscription = false;
    this.isPayment = true;
  }

  calculateAmount(): void {
    this.paymentForm.patchValue({
      'amount':this.selectedSubscription?.periodicAmount??0
    });
  }

  onMultiplierChange(): void {
    this.calculateAmount();
  }

  onSelectPaymentMethod(paymentMethod: string): void {
    this.paymentNetwork = paymentMethod;

    if (this.paymentNetwork === 'card') {
      this.isWallet = false;
    } else {
      if (this.paymentNetwork === 'omsn') {
       this.paymentNetworkOtpion='maxit';
      }
      this.isWallet = true;
    }

    // Update UI to show selected method
    const methods = document.querySelectorAll('.payment-method');
    methods.forEach(element => {
      if (element.getAttribute('data-method') === paymentMethod) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });
  }

  isValid(): boolean {
    if (this.paymentNetwork === 'card') {
      return true;
    } else {
      const phone = this.paymentForm.value.phone;
      return phone != null && phone.length >= 9;
    }
  }

  processPayment(): void {
    this.clickedPayForm=true;
    if (!this.isValid() || !this.selectedSubscription) {
      this.clickedPayForm=false
      return;
    }

    if (this.idempotencyKey === '') {
      this.idempotencyKey = crypto.randomUUID();
    }
    const form =this.paymentForm.value;
    // First save the housing payment
    const housingPayment: HPaymentDto = {
      subscriptionId: this.selectedSubscription.id,
      amount: this.paymentForm.value.amount,
      paymentMean:form.phone,
      paymentNetwork:this.paymentNetwork.toUpperCase(),
      paymentNetworkOption:this.paymentNetworkOtpion,
      currencyCode:'XOF',
      requestId:crypto.randomUUID()
    };

    this.hpaymentService.initiateHousingPayment(  housingPayment).subscribe({
      
      next :(resp: PaymentResponseDto) => {

        // Now process the payment through the general payment service
        if(resp.status==='PENDING'){
          this.paymentForm.reset();
          this.clickedPayForm=false;
           this.isPayment=false;
          if(housingPayment.paymentNetwork?.toUpperCase()==='CARD'){
              window.open(resp.paymentUrl,'_self');
          }else {
            this.qrCode=resp.paymentUrl!;
            this.finalizePayment(resp.reference!);

        }
      }else {
        this.clickedPayForm=false;
      }
    },
      error: (error:HttpErrorResponse) => {
        this.clickedPayForm=false;
        this.idempotencyKey = '';
        this.messageType = 'text-danger';
        this.message = error.error?.message || 'Erreur lors de la sauvegarde du paiement';
        const elt = document.getElementById('modalPayment');
        const modAdd = new bootstrap.Modal(elt!!);
        modAdd.show();
        
      }
    });
  }

  resetSearch(): void {
    this.searchForm.reset();
    this.customerData = undefined;
    this.promoters = [];
    this.selectedPromoter = undefined;
    this.promoterSubscriptions = [];
    this.selectedSubscription = undefined;
    this.isSearching = true;
    this.isSelectingPromoter = false;
    this.isSelectingSubscription = false;
    this.isPayment = false;
    this.message = '';
  }

  goBack(): void {
    if (this.isPayment) {
      this.isPayment = false;
      this.isSelectingSubscription = true;
    } else if (this.isSelectingSubscription) {
      this.isSelectingSubscription = false;
      this.isSelectingPromoter = true;
    } else if (this.isSelectingPromoter) {
      this.isSelectingPromoter = false;
      this.isSearching = true;
    }
  }

  getFrequencyLabel(frequency?: string): string {
    const labels: { [key: string]: string } = {
      'MONTHLY': 'Mensuel',
      'QUARTERLY': 'Trimestriel',
      'SEMI_ANNUAL': 'Semestriel',
      'ANNUAL': 'Annuel'
    };
    return labels[frequency || ''] || frequency || '';
  }

   async finalizePayment(reference:string){
      
      this.receiptService.getPaymentDetails(
        reference
      ).subscribe({
        next:(resp)=>{
          console.log(resp);
          if(resp.status =='PENDING'){
            setTimeout(()=>
              {
                this.finalizePayment(reference);
              },
              20000);
          }else {
            this.router.navigateByUrl('receipt/'+reference);
            
          }
          
        },
        
      });
    }
    openUrl(url:string){
       window.open(url,'_self');
    }
}
